import { GetterTree } from "vuex";

import { RootState } from "@/store";

import { State } from "./state";

export type Getters = {
  top5Computers(state: State): Array<any>;
  top5ComputersError(state: State): string;
  top5Groups(state: State): Array<any>;
  eventTrends(state: State): Array<any>;
  topComputers(state: State): Array<any>;
  blocksOverTime(state: State): Array<any>;
  alertSummary(state: State): Array<any>;
  companyOverview(state: State): Array<any>;
  knownThreads(state: State): Array<any>;
  numberOfBlocksByTime(state: State): Array<any>;
  companyOverviewLoading(state: State): boolean;
  alertSummaryLoading(state: State): boolean;
  knownThreadsLoading(state: State): boolean;
  top5GroupsLoading(state: State): boolean;
  top5ComputersLoading(state: State): boolean;
};

export const getters: GetterTree<State, RootState> & Getters = {
  top5Computers: (state) => state.top5Computers,
  top5ComputersError: (state) => state.top5ComputersError,
  top5Groups: (state) => state.top5Groups,
  eventTrends: (state) => state.eventTrends,
  topComputers: (state) => state.topComputers,
  blocksOverTime: (state) => state.blocksOverTime,
  alertSummary: (state) => state.alertSummary,
  companyOverview: (state) => state.companyOverview,
  knownThreads: (state) => state.knownThreads,
  numberOfBlocksByTime: (state) => state.numberOfBlocksByTime,
  companyOverviewLoading: (state) => state.companyOverviewLoading,
  alertSummaryLoading: (state) => state.alertSummaryLoading,
  knownThreadsLoading: (state) => state.knownThreadsLoading,
  top5GroupsLoading: (state) => state.top5GroupsLoading,
  top5ComputersLoading: (state) => state.top5ComputersLoading,
};
